module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.failure) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _c('div', [(_vm.initing) ? _c('div', {
    staticStyle: {
      "height": "100%",
      "text-align": "center"
    }
  }, [_c('h4', [_vm._v("Loading")]), _vm._v(" "), _vm._m(1)]) : [(_vm.nestedMode) ? _c('div', {
    staticClass: "startjobtitle"
  }, [_c('div', {
    staticClass: "center-align"
  }, [_c('h5', {
    staticClass: "bold startjob"
  }, [_vm._v("Start Nested Job: " + _vm._s(_vm.nestedJobName))]), _vm._v(" "), _c('h5', {
    staticClass: "bold startjob"
  }, [_vm._v("Choose your orientation optimization")])]), _vm._v(" "), (!_vm.subscription) ? _c('div', {
    staticClass: "center-align startjob"
  }, [_c('p', {
    staticClass: "startjob"
  }, [_vm._v("This job costs " + _vm._s(_vm.costString) + ". 1 credit for each part file to be nested.\n                    "), _c('buy-credits', {
    attrs: {
      "showModal": _vm.showModal
    },
    on: {
      "update:showModal": function($event) {
        _vm.showModal = $event
      },
      "update:show-modal": function($event) {
        _vm.showModal = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "display",
      fn: function(props) {
        return _c('a', {
          on: {
            "click": props.open
          }
        }, [_vm._v("Buy Subscription")])
      }
    }], null, false, 2185934191)
  })], 1)]) : _vm._e()]) : _c('div', {
    staticClass: "startjobtitle"
  }, [_vm._m(2), _vm._v(" "), (!_vm.subscription) ? _c('div', {
    staticClass: "center-align startjob"
  }, [_c('p', {
    staticClass: "startjob"
  }, [_vm._v("This job costs " + _vm._s(_vm.costString) + ".\n                    "), _c('buy-credits', {
    attrs: {
      "showModal": _vm.showModal
    },
    on: {
      "update:showModal": function($event) {
        _vm.showModal = $event
      },
      "update:show-modal": function($event) {
        _vm.showModal = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "display",
      fn: function(props) {
        return _c('a', {
          on: {
            "click": props.open
          }
        }, [_vm._v("Buy Subscription")])
      }
    }], null, false, 2185934191)
  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.nestedMode) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partParamsAll),
      expression: "partParamsAll"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "useForAll"
    },
    domProps: {
      "checked": Array.isArray(_vm.partParamsAll) ? _vm._i(_vm.partParamsAll, null) > -1 : (_vm.partParamsAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.partParamsAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.partParamsAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.partParamsAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.partParamsAll = $$c
        }
      }, function($event) {
        return _vm.switchPartParamAll()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "useForAll"
    }
  }, [_vm._v("Use the same parameters for all nested parts")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(!_vm.partParamsAll) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('div', {
    staticClass: "block-dots top center-align"
  }, _vm._l((_vm.files), function(fileObj, index) {
    return _c('div', {
      key: fileObj.id,
      staticClass: "tooltip-wrp"
    }, [_c('div', {
      staticClass: "file-dot",
      class: {
        'selected': index === _vm.fileIndex
      },
      on: {
        "click": function($event) {
          return _vm.switchFile(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tooltip"
    }, [_c('span', {
      staticClass: "tooltipvalue"
    }, [_vm._v(_vm._s(fileObj.name))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_c('div', {
    staticClass: "col s4 a3dlightgray",
    staticStyle: {
      "border-right": "6px solid white",
      "position": "relative"
    }
  }, [(_vm.expertAdvice || _vm.files[_vm.fileIndex].optMinDist || _vm.files[_vm.fileIndex].optMaxDist) ? _c('div', {
    staticClass: "info-overlay"
  }, [_c('div', {
    staticClass: "blur"
  }), _vm._v(" "), _c('div', {
    staticClass: "content valign-wrapper"
  }, [_c('h6', {
    staticClass: "bold startjobtitle"
  }, [_vm._v("\n                                In order to select weights, please deselect " + _vm._s(_vm.selectedColumn) + ".")])])]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "bold startjobtitle"
  }, [_vm._v("\n                        Use the experience of \"Design for Additive\" experts by weighing each of the following 3 factors:")]), _vm._v(" "), _c('div', {
    staticClass: "startjobtitle"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('p', [_vm._v("Minimum Build Time")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.files[_vm.fileIndex].weights[0]),
      expression: "files[fileIndex].weights[0]",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "id": "minbuildtime",
      "min": "0",
      "max": "1",
      "step": "any",
      "disabled": _vm.files[_vm.fileIndex].optMinDist || _vm.loading
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].weights[0])
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.files[_vm.fileIndex].weights, 0, _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Minimum Material Consumption")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.files[_vm.fileIndex].weights[1]),
      expression: "files[fileIndex].weights[1]",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "id": "minmaterialconsumption",
      "min": "0",
      "max": "1",
      "step": "any",
      "disabled": _vm.files[_vm.fileIndex].optMinDist || _vm.loading
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].weights[1])
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.files[_vm.fileIndex].weights, 1, _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Minimum Support Structure Removal")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.files[_vm.fileIndex].weights[2]),
      expression: "files[fileIndex].weights[2]",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "id": "minsupportstructure",
      "min": "0",
      "max": "1",
      "step": "any",
      "disabled": _vm.files[_vm.fileIndex].optMinDist || _vm.loading
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].weights[2])
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.files[_vm.fileIndex].weights, 2, _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('p', [_vm._v("Minimum Distortion")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.files[_vm.fileIndex].weights[3]),
      expression: "files[fileIndex].weights[3]",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "id": "minimumdistortion",
      "min": "0",
      "max": "1",
      "step": "any",
      "disabled": _vm.files[_vm.fileIndex].optMinDist || _vm.loading
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].weights[3])
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.files[_vm.fileIndex].weights, 3, _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col s4 a3dlightgray",
    staticStyle: {
      "border-left": "6px solid white"
    }
  }, [_c('div', {
    staticClass: "startjobtitle"
  }, [(_vm.nestedMode) ? _c('h6', {
    staticClass: "bold"
  }, [_vm._v("\n                            Maximize part density while minimizing thermal distortion for each part.\n                        ")]) : _c('h6', {
    staticClass: "bold"
  }, [_vm._v("\n                            Use Siemens proven ability to computationally minimize thermal distortion.\n                        ")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('p', {
    staticClass: "startjobor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].optMinDist),
      expression: "files[fileIndex].optMinDist"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "mindistortion",
      "disabled": (_vm.expertAdvice || _vm.files[_vm.fileIndex].optMaxDist) || _vm.loading,
      "checked": "unchecked"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].optMinDist) ? _vm._i(_vm.files[_vm.fileIndex].optMinDist, null) > -1 : (_vm.files[_vm.fileIndex].optMinDist)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[_vm.fileIndex].optMinDist,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "optMinDist", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "optMinDist", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "optMinDist", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "mindistortion"
    }
  }, [_vm._v("Minimal distortion is most important")])]), _vm._v(" "), (_vm.files[_vm.fileIndex].optMinDist) ? _c('p', {
    staticClass: "startjobor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].isHeatTreatment),
      expression: "files[fileIndex].isHeatTreatment"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isHeatTreatment",
      "disabled": (_vm.expertAdvice || _vm.files[_vm.fileIndex].optMaxDist) || _vm.loading,
      "checked": "unchecked"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].isHeatTreatment) ? _vm._i(_vm.files[_vm.fileIndex].isHeatTreatment, null) > -1 : (_vm.files[_vm.fileIndex].isHeatTreatment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[_vm.fileIndex].isHeatTreatment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "isHeatTreatment", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "isHeatTreatment", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "isHeatTreatment", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isHeatTreatment"
    }
  }, [_vm._v("Perform \"stress relief\" before removing parts from the build plate")])]) : _vm._e(), _vm._v(" "), (_vm.files[_vm.fileIndex].optMinDist) ? _c('p', {
    staticClass: "startjobor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].isMinPeeling),
      expression: "files[fileIndex].isMinPeeling"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isMinPeeling",
      "disabled": (_vm.expertAdvice || _vm.files[_vm.fileIndex].optMaxDist) || _vm.loading,
      "checked": "unchecked"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].isMinPeeling) ? _vm._i(_vm.files[_vm.fileIndex].isMinPeeling, null) > -1 : (_vm.files[_vm.fileIndex].isMinPeeling)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[_vm.fileIndex].isMinPeeling,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "isMinPeeling", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "isMinPeeling", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "isMinPeeling", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isMinPeeling"
    }
  }, [_vm._v("Minimal recoater interference is more important than overall dimensional accurary.")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col s4 a3dlightgray",
    staticStyle: {
      "border-left": "6px solid white"
    }
  }, [_c('div', {
    staticClass: "startjobtitle"
  }, [(_vm.nestedMode) ? _c('h6', {
    staticClass: "bold"
  }, [_vm._v("\n                            Minimize build time while controlling thermal distortion for each part.\n                        ")]) : _c('h6', {
    staticClass: "bold"
  }, [_vm._v("\n                            Use Siemens ability to find the least amount of build time within a constraint.\n                        ")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('p', {
    staticClass: "startjobor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].optMaxDist),
      expression: "files[fileIndex].optMaxDist"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "maxDistFlag",
      "disabled": (_vm.expertAdvice || _vm.files[_vm.fileIndex].optMinDist) || _vm.loading
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].optMaxDist) ? _vm._i(_vm.files[_vm.fileIndex].optMaxDist, null) > -1 : (_vm.files[_vm.fileIndex].optMaxDist)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[_vm.fileIndex].optMaxDist,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "optMaxDist", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "optMaxDist", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "optMaxDist", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "maxDistFlag"
    }
  }, [_vm._v("Set a limit on maximum thermal distortion")])])]), _vm._v(" "), (_vm.files[_vm.fileIndex].optMaxDist) ? _c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n                                What is the maximum thermal distortion allowable on this part? +/-\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "input-field inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].maxDist),
      expression: "files[fileIndex].maxDist"
    }],
    attrs: {
      "id": "maxDist",
      "type": "number",
      "min": "0",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].maxDist)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[_vm.fileIndex], "maxDist", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "maxDist"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("\n                                millimeters\n                            ")]), _vm._v(" "), (Array.isArray(_vm.validationError) && _vm.validationError[_vm.fileIndex]) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n                                " + _vm._s(_vm.validationError[_vm.fileIndex]) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "startjobor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].isHeatTreatment),
      expression: "files[fileIndex].isHeatTreatment"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isHeatTreatment",
      "disabled": (_vm.expertAdvice || _vm.files[_vm.fileIndex].optMinDist) || _vm.loading,
      "checked": "unchecked"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].isHeatTreatment) ? _vm._i(_vm.files[_vm.fileIndex].isHeatTreatment, null) > -1 : (_vm.files[_vm.fileIndex].isHeatTreatment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[_vm.fileIndex].isHeatTreatment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "isHeatTreatment", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "isHeatTreatment", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "isHeatTreatment", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isHeatTreatment"
    }
  }, [_vm._v("Perform \"stress relief\" before removing parts from the build plate")])]), _vm._v(" "), (_vm.files[_vm.fileIndex].optMinDist) ? _c('p', {
    staticClass: "startjobor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].isMinPeeling),
      expression: "files[fileIndex].isMinPeeling"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isMinPeeling",
      "disabled": (_vm.expertAdvice || _vm.files[_vm.fileIndex].optMaxDist) || _vm.loading,
      "checked": "unchecked"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].isMinPeeling) ? _vm._i(_vm.files[_vm.fileIndex].isMinPeeling, null) > -1 : (_vm.files[_vm.fileIndex].isMinPeeling)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[_vm.fileIndex].isMinPeeling,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "isMinPeeling", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "isMinPeeling", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "isMinPeeling", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isMinPeeling"
    }
  }, [_vm._v("Minimal recoater interference is more important than overall dimensional accurary.")])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), (!_vm.partParamsAll) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('div', {
    staticClass: "block-dots bottom center-align"
  }, _vm._l((_vm.files), function(fileObj, index) {
    return _c('div', {
      key: fileObj.id,
      staticClass: "tooltip-wrp"
    }, [_c('div', {
      staticClass: "file-dot",
      class: {
        'selected': index === _vm.fileIndex
      },
      on: {
        "click": function($event) {
          return _vm.switchFile(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tooltip"
    }, [_c('span', {
      staticClass: "tooltipvalue"
    }, [_vm._v(_vm._s(fileObj.name))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.nestedMode) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "a3dlightgray col s12 restrictions-block"
  }, [_c('div', {
    staticClass: "restrictions"
  }, [_c('div', {
    staticClass: "restriction"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optimizationConstrain),
      expression: "optimizationConstrain"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "optimizationConstrain",
      "disabled": _vm.loading || _vm.submitting
    },
    domProps: {
      "checked": Array.isArray(_vm.optimizationConstrain) ? _vm._i(_vm.optimizationConstrain, null) > -1 : (_vm.optimizationConstrain)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.optimizationConstrain,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.optimizationConstrain = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.optimizationConstrain = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.optimizationConstrain = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "optimizationConstrain"
    }
  }, [_vm._v("Constrain the optimization to a range of orientations and/or specify faces of the part where supports should not be attached")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading && _vm.statusMessage) ? _c('div', {
    staticClass: "col s12 center-align status-message"
  }, [_vm._v("\n                    " + _vm._s(_vm.statusMessage) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "progress"
  }, [(_vm.remeshingPart && _vm.remeshingProgress > 0) ? _c('div', {
    staticClass: "determinate",
    style: ({
      width: _vm.remeshingProgress * 100 + '%'
    })
  }) : _c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "col s12 center-align"
  }, [(_vm.subscription || _vm.user.credits.length >= this.files.length) ? _c('a', {
    staticClass: "btn a3d",
    on: {
      "click": _vm.validate
    }
  }, [(_vm.subscription) ? [_vm._v("\n                                Start job\n                            ")] : [_vm._v("\n                                Start job (" + _vm._s(_vm.costString) + ")\n                            ")]], 2) : [_c('a', {
    staticClass: "a3d btn",
    on: {
      "click": _vm.buymodal
    }
  }, [_vm._v("Buy Subscription")]), _vm._v(" "), _c('div', {
    staticClass: "note bold"
  }, [_vm._v("This job costs " + _vm._s(_vm.costString))])]], 2), _vm._v(" "), (_vm.nestedMode && !_vm.subscription) ? _c('div', {
    staticClass: "col s12 center-align note"
  }, [_vm._v("\n                        1 credit for each part file to be nested.\n                    ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('modal', {
    ref: "summarymodal",
    attrs: {
      "name": "summarymodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "75%"
    }
  }, [_c('job-summary', {
    attrs: {
      "config": _vm.files[0].config,
      "jobDescription": _vm.jobDescription,
      "submit": _vm.submitSingle
    }
  })], 1)]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s6 offset-s3 center-align",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h5', [_vm._v("\n            There was a problem processing your file.  We will return to you to the dashboard in a few seconds.  If this consumed one of your credits, please contact us with details and we will correct this.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader-wrapper small active"
  }, [_c('div', {
    staticClass: "spinner-layer"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gap-patch"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-align"
  }, [_c('h5', {
    staticClass: "bold startjob"
  }, [_vm._v("Start Job: choose your orientation optimization")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c0f179e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c0f179e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Start.vue
// module id = 485
// module chunks = 1